import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ClearedRec18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      d='M8.50012 11.0605L13.5608 6.00001L12.5001 4.93934L8.50011 8.93925L6.50009 6.93934L5.43946 8.00003L8.50012 11.0605Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.5 1.25C0.809644 1.25 0.25 1.80964 0.25 2.5V13.5C0.25 14.1904 0.809644 14.75 1.5 14.75H3.75V16.2929C3.75 17.4065 5.09643 17.9642 5.88388 17.1768L8.31066 14.75H16.5C17.1904 14.75 17.75 14.1904 17.75 13.5V2.5C17.75 1.80964 17.1904 1.25 16.5 1.25H1.5ZM1.75 13.25V2.75H16.25V13.25H7.68934L5.25 15.6893V13.25H1.75Z'
      fill='currentColor'
    />
  </Svg>
);

ClearedRec18.displayName = 'ClearedRec18';
export default ClearedRec18;
